// The workspace navigation of the Alice shell (Sidebar.vue) as plain data, so
// who sees which item is unit-testable without mounting the component.
//
// Guests (external magic-link accounts with the `guest` claim) get Projects
// plus a Guide item that reopens their intro wizard; everything else is for
// the Valsplat team. The router keeps guests off the team pages as well, so
// hiding an item here is about a coherent UI, not about access.

const TEAM_ITEMS = [
  { key: "projects", icon: "folder", label: "Projects", to: "/projects" },
  { key: "skills", icon: "layers", label: "Skills", to: "/skills" },
  { key: "previews", icon: "grid", label: "Previews", to: "/previews" },
  { key: "admin", icon: "shield", label: "Admin", to: "/admin" },
];

const TEAM_BOTTOM_ITEMS = [
  {
    key: "requests",
    icon: "lightbulb",
    label: "Feature requests",
    to: "/requests",
  },
  { key: "changelog", icon: "book", label: "Changelog", to: "/changelog" },
  // How to connect Claude and ChatGPT to Alice (the Valsplat MCP connector).
  { key: "mcp", icon: "plug", label: "Alice in Claude & ChatGPT", to: "/mcp" },
];

// Guests may have grants to several projects, so they keep the list.
const GUEST_ITEMS = [
  { key: "projects", icon: "folder", label: "Projects", to: "/projects" },
];

// No route: Sidebar.vue reopens the guest intro wizard instead.
const GUEST_BOTTOM_ITEMS = [{ key: "guide", icon: "book", label: "Guide" }];

// { items, bottomItems } for the signed-in user, with `active` set on the
// item whose key is `activeKey`.
export function sidebarItems({ isGuest = false, activeKey = "" } = {}) {
  const mark = (list) =>
    list.map((item) => ({ ...item, active: item.key === activeKey }));
  return isGuest
    ? { items: mark(GUEST_ITEMS), bottomItems: mark(GUEST_BOTTOM_ITEMS) }
    : { items: mark(TEAM_ITEMS), bottomItems: mark(TEAM_BOTTOM_ITEMS) };
}
